// Shorten a string to less than maxLen characters without truncating words.
export function shorten(str: string, maxLen: number, separator = " ") {
    if (str?.length <= maxLen) return str;
    return str?.slice(0, str.lastIndexOf(separator, maxLen)) + "...";
}

export function isNullOrWhitespace(input: string | undefined) {
    return !input || !input.trim();
}
